import { render, staticRenderFns } from "./AreasOfInterest.vue?vue&type=template&id=03a19cc4&scoped=true&"
import script from "./AreasOfInterest.vue?vue&type=script&lang=js&"
export * from "./AreasOfInterest.vue?vue&type=script&lang=js&"
import style0 from "./AreasOfInterest.vue?vue&type=style&index=0&id=03a19cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a19cc4",
  null
  
)

export default component.exports